import React, { FC, useEffect, useRef, useState, useMemo, useCallback } from "react";
import { Button, Table, Tooltip, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IDetailList } from "../../purchaseEnquiryType"
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { DetailType } from "@/types/ScmEnums";
import { YhBut } from "@/components/YhButton";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { supplierMapModel } from "@/utils/supplierMap";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { PictureOutlined } from "@ant-design/icons";
import { LookPictureModal } from "@/views/lookPicture";

const returnList: any = {
    //配件厂家
    'approval-type.001': 'supplier-type.material',
    //辅油厂家
    'approval-type.002': 'supplier-type.002',
    //轮胎厂家
    'approval-type.003': 'supplier-type.001',
}
export const TableBox: FC<RouterParamType> = ({ id, mode, materialList }) => {
    const {
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        detailLookForm,
        detailAddForm,
        supplier,
        changeSupplierLogData,
        setDetaiAddDataRow,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setAddModalVisible,
        setDetailDataSource,
        detailDetailList,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl,
        exportPurchaseEnquiryDetail,
        setSelectSupplier,
        setChangeSupplierVisible
    } = usePurchaseEnquiryDetailsModel();
    const { user: { roles }, setLoadingInfo, supplieAllList } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();
    const { getSupplierField } = supplierMapModel();
    const formRef = useRef<any>()
    const typeList = {
        "add": detailAddList,
        "edit": detailDataSource,
        "look": detailLookList,
    }
    const { getSelectedDictOne, getTreeNodeName } = useDictModel();
    const [dataSource, setDataSource] = useState<IDetailList[]>([]);
    const [imageModalVisible, setImageModalVisible] = useState(false);
    const [currentMaterialCode, setCurrentMaterialCode] = useState("");
    // 打开图片模态框
    const handleOpenImageModal = (materialCode: string) => {
        setCurrentMaterialCode(materialCode);
        setImageModalVisible(true);
    };

    // 关闭图片模态框
    const handleCloseImageModal = () => {
        setImageModalVisible(false);
        setCurrentMaterialCode("");
    };
    useEffect(() => {
        const dataList = mode === 'add' ? detailAddList : mode === 'edit' ? detailDataSource : detailLookList
        if (dataList != undefined && dataList.length > 0) {
            formRef.current = dataList
            setDataSource(dataList);
        }
        //询价统计生成询价单
        if (mode === 'add' && materialList != undefined && materialList.length > 0) {
            formRef.current = materialList
            setDataSource(materialList);
        }
    }, [detailAddList, detailDataSource, detailLookList])

    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const onHistoryModel = (record: IDetailList) => {
        setHistoryVisible(true);
        setHistoryRow(record);
    }
    // 删除(做限制)
    const onRemove = (mode: string) => {
        detailDetailList(mode)
    }

    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        if (list && list.length) {
            let dataList = mode === 'edit' ? detailDataSource : detailAddList;
            const newData = dataList.map((e: IDetailList) => {
                const index = list.findIndex((item: any) => e.id === item.id);
                if (index > -1 && detailEditForm.approveTypeCode == 'approval-type.001') {
                    const currentItem = list[index];
                    const supplierColumns: any = {}
                    supplier.forEach(s => {
                        supplierColumns[`${s.idx}ControlPrice`] = currentItem[`${s.idx}Price`];
                    })
                    let newData = {
                        ...e,
                        ...supplierColumns,
                        vehicleModel: currentItem.vehicleModel,
                        upperClothBrand: currentItem.upperClothBrand,
                        chassisBrand: currentItem.chassisBrand,
                        model: currentItem.model,
                        unitName: currentItem.unitName,
                        unitCode: currentItem.unitCode,
                        num: currentItem.num,
                        details: e?.details?.map((detail: any) => {
                            const idx = getSupplierField('code', detail.supplierCode, 'idx');
                            return {
                                ...detail,
                                controlPrice: idx ? currentItem[`${idx}Price`] : detail.controlPrice
                            }
                        })
                    }
                    return newData;
                }
                if (index > -1 && detailEditForm.approveTypeCode !== 'approval-type.001') {
                    const currentItem = list[index];
                    let newData = {
                        ...e,
                        ...currentItem,
                        materialCode: e.materialCode,
                        materialName: e.materialName
                    }
                    return newData;
                }
                else {
                    return e;
                }
            });
            mode === "edit" ? setDetailDataSource(newData) : setDetailAddList(newData);
        }
    }

    const action = <>
        {mode !== "look" && <>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ADDGOOD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={typeForm[mode].status == "purchase_enquiry.underway" || typeForm[mode].status == "purchase_enquiry.end"}
                    onClick={() => setAddModalVisible(true)}
                >新增配件</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_ONREMOVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={typeForm[mode].status == "purchase_enquiry.underway" || typeForm[mode].status == "purchase_enquiry.end"}
                    onClick={() => { onRemove(mode) }}
                >批量删除</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_EXPORTDETIALPURCHASE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={() => exportPurchaseEnquiryDetail(typeForm[mode].code)}
                >导出</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_UPLOADDETAIL}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(detailEditForm.approveTypeCode == 'approval-type.001' ? `/zzw-vrm/purchaseEnquiry/importDetails` : `/zzw-vrm/purchaseEnquiry/ltFyImportDetails`, importCallback)}>
                    <Button className="mr-5" type="primary" shape="round">导入</Button>
                </Upload>
            </YhAuth>
        </>}
    </>;

    const startColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '商品编码',
            width: 150,
            dataIndex: 'materialCode',
            align: 'center',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Tooltip placement="topLeft" title={record.materialCode}>
                        <p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text} {changeSupplierLogData.find((item: any) => item.materialCode == text) && <span style={{ background: "orange", color: "white", padding: '0 2px' }}>更</span>}</p></Tooltip>
                    <PictureOutlined
                        style={{ color: '#009688', cursor: 'pointer', marginLeft: 4, fontSize: '22px' }}
                        onClick={() => handleOpenImageModal(record.materialCode)} // 点击打开图片模态框
                    />
                </div>
            ),
        }, {
            title: '商品名称',
            width: 150,
            dataIndex: 'materialName',
            align: 'center',
            render: (text: any, record: any) => <YhTootip text={text} style={{ maxWidth: "150px" }} />,
        }, {
            title: '品牌',
            width: 110,
            dataIndex: 'brandName',
            align: 'center',
        }, {
            title: '上装品牌',
            width: 110,
            dataIndex: 'upperClothBrand',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
        }, {
            title: '底盘品牌',
            width: 110,
            dataIndex: 'chassisBrand',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
        }, {
            title: '适用车型',
            width: 150,
            align: 'center',
            dataIndex: 'vehicleModel',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
        }, {
            title: '规格型号',
            width: 150,
            dataIndex: 'model',
            align: 'center',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
        }, {
            title: '单位',
            width: 80,
            align: 'center',
            dataIndex: 'unitCode',
            editType: 'select',
            options: getSelectedDictOne(DictCodeEnmu.MATERIAL_UNIT),
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
            render: (text: string) => getTreeNodeName(text as string),
        }, {
            title: '数量',
            width: 80,
            align: 'center',
            editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
            dataIndex: 'num',
        },
        ...((str) => {
            if (str) {
                return [
                    {
                        title: '选中供应商',
                        width: 200,
                        align: 'center',
                        dataIndex: 'supplierCode',
                        editType: 'select',
                        options: supplieAllList.filter((list: any) => list.typeCode == returnList[typeForm[mode].approveTypeCode]).map((item: any) => { return { value: item.code, label: item.name, } }),
                        editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
                        render: (text: string, res: any) => res.supplierCode ? res.supplierName : ''
                    },
                    {
                        title: '含税单价',
                        width: 80,
                        align: 'center',
                        editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
                        dataIndex: 'price',
                    },
                    {
                        title: '交货期',
                        width: 80,
                        align: 'center',
                        editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
                        dataIndex: 'deliveryTime',
                    },
                    {
                        title: '产地',
                        dataIndex: 'producingArea',
                        width: 120,
                        align: 'center',
                        editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
                    },
                ]
            } else {
                return []
            }
        })(typeForm[mode].approveTypeCode == 'approval-type.002' || typeForm[mode].approveTypeCode == 'approval-type.003'),
    ];

    const endColumns = [
        {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                (mode == "add" || (mode == "edit" && detailEditForm.status == "purchase_enquiry.init")) ? <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                /> : (mode == "edit" && (detailEditForm.status == "purchase_enquiry.end" || detailEditForm.status == "purchase_enquiry.audited")) ? <YhBut
                    type="warning"
                    txt="变更"
                    click={() => { setSelectSupplier(record); setChangeSupplierVisible(true) }}
                /> : <></>
        }
    ]

    const supplierColumns = supplier.map(e => {
        return {
            title: e.fullName,
            dataIndex: e.idx,
            children: [
                {
                    title: '控制价',
                    dataIndex: e.idx + 'ControlPrice',
                    width: 80,
                    align: 'center',
                    editable: mode == 'add' || (mode == 'edit' && typeForm[mode].status == "purchase_enquiry.init"),
                },
                {
                    title: '含税单价',
                    dataIndex: e.idx + 'OfferPrice',
                    width: 80,
                    align: 'center',
                    render: (text: any, res: any) => text !== null && text !== undefined && text !== '' ? <div style={{ color: (res[e.idx + 'ControlPrice'] as number) < (text as number) ? 'red' : 'black', fontWeight: 'bolder' }}>{text}</div> : '',
                },
                {
                    title: '交货期',
                    dataIndex: e.idx + 'DeliveryTime',
                    width: 80,
                    align: 'center',
                },
                {
                    title: '产地',
                    dataIndex: e.idx + 'ProducingArea',
                    width: 80,
                    align: 'center',
                },
                {
                    title: '综合评分',
                    dataIndex: e.idx + 'TotalScore',
                    width: 80,
                    align: 'center',
                    render: (text: any, res: any) => text ? <div style={{ width: '100%', height: '100%', fontWeight: 'bolder', padding: '0px 10px', backgroundColor: (e.fullName === typeList[mode][typeList[mode].findIndex((item: any) => res?.materialCode === item?.materialCode)]?.supplierName ? "#66e166" : "white") }}>{text}</div> : '',
                },
            ]
        }
    })

    const removeMaterial = (record: IDetailList) => {
        detailDetailList(mode, record)
    }
    const newSelectColumns = (cols: any) =>
        cols.map((col: any, index: number) => {
            return {
                ...col,
                children: typeForm[mode].approveTypeCode == 'approval-type.001' ? col.children?.map((item: any, idx: number) => {
                    return {
                        ...item,
                        onCell: (record: IDetailList, rowIndex: number) => ({
                            colIndex: idx + 1,
                            rowIndex,
                            record,
                            rules: item?.rules,
                            options: item?.options,
                            editType: item?.editType,
                            editable: item?.editable,
                            onSelectChange: item?.onSelectChange,
                            onSelectFocus: item?.onSelectFocus,
                            dataIndex: item.dataIndex,
                            title: item.title,
                            handleSave: handleSaveDetail,
                        }),
                    }
                }) : false,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseEnquiry", "roleCodes": roles };
        const columns = getRoleColumns("purchaseEnquiry", "明细", newSelectColumns(startColumns), params);
        if ((supplier == null || supplier.length == 0) && typeForm[mode].approveTypeCode !== 'approval-type.001') {
            return [...columns, ...endColumns];
        }
        else {
            return [...columns, ...newSelectColumns(supplierColumns), ...endColumns]
        }
    }, [startColumns, supplier]);

    const handleSave = async (row: IDetailList) => {
        let { controlPrice, num, price, deliveryTime, producingArea } = row
        row.num = +formatNum(num)
        row.controlPrice = +formatNum(controlPrice)
        row.price = +formatNum(price)
        row.deliveryTime = +formatNum(deliveryTime)
        row.producingArea = producingArea
        let newData: any = formRef.current;
        row.unitName = getTreeNodeName(row.unitCode as string)
        row.supplierCode = row.supplierCode
        row.supplierName = supplieAllList.find((item: any) => item.code == row.supplierCode)?.name
        const index = newData.findIndex((item: any) => row.materialCode === item.materialCode);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        setTopButsControl(true)
    }

    const handleSaveDetail = (row: IDetailList, dataIndex: string) => {
        let dataList = mode === 'edit' ? detailDataSource : detailAddList;
        const index = dataList.findIndex((item: any) => row.materialCode === item.materialCode);
        if (index > -1) {
            const newData = [...dataList];
            newData[index] = { ...newData[index], ...row };
            newData[index] = {
                ...newData[index],
                details: newData[index].details.map((e: any) => {
                    if (e.supplierCode === getSupplierField('idx', dataIndex.replace("ControlPrice", ""), 'code')) {
                        return { ...e, controlPrice: Number(row[dataIndex]) };
                    }
                    return e;
                })
            };

            mode === "edit" ? setDetailDataSource(newData) : setDetailAddList(newData);
            formRef.current = newData;
            setTopButsControl(true);
        }
    }
    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }

    return (
        <>
            {action}
            <Table
                style={{ marginTop: 10 }}
                bordered
                rowClassName={(record) => (!record.supplierName && (typeForm[mode].status == 'purchase_enquiry.end' || typeForm[mode].status == 'purchase_enquiry.audited' || typeForm[mode].status == 'purchase_enquiry.reject')) ? "editable-row yh-edit-table-tr strikethroughOrange" :
                    'editable-row yh-edit-table-tr'
                }
                rowKey={record => record.materialCode as string}
                rowSelection={
                    mode === DetailType.look ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                            setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeDetailDataRow(selectedRows, mode)
                        }
                    }}
                columns={roleColumns}
                dataSource={dataSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{
                    x: 'max-content', y: 530
                }}
            />
            <LookPictureModal
                visible={imageModalVisible}
                materialCode={currentMaterialCode}
                onClose={handleCloseImageModal}
            />
        </>
    )
}
